"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15,664],{

/***/ 5664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ButtonGroup": function() { return /* reexport */ ButtonGroup; },
  "IconButton": function() { return /* reexport */ button_IconButton; },
  "default": function() { return /* reexport */ Button/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/button/ButtonGroup.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ButtonGroup = function(_param) {
    var children = _param.children, className = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: (0,functions.classnames)('button-group', className)
    }, rest, {
        children: children
    })));
};


// EXTERNAL MODULE: ./components/base/button/Button.tsx
var Button = __webpack_require__(5500);
;// CONCATENATED MODULE: ./components/base/button/IconButton.tsx



function IconButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IconButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function IconButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = IconButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function IconButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconButton = function(_param, ref) {
    var children = _param.children, rest = IconButton_objectWithoutProperties(_param, [
        "children"
    ]);
    if (/*#__PURE__*/ react.isValidElement(children)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, IconButton_objectSpread({
            className: "button--icon",
            iconBefore: children,
            ref: ref
        }, rest)));
    }
    return null;
};
/* harmony default export */ var button_IconButton = (/*#__PURE__*/react.forwardRef(IconButton));

;// CONCATENATED MODULE: ./components/base/button/index.tsx





/***/ }),

/***/ 3340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _IconListItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7731);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconList = function(props) {
    var _align = props.align, align = _align === void 0 ? 'horizontal' : _align, children = props.children, className = props.className, _data = props.data, data = _data === void 0 ? [] : _data, rest = _objectWithoutProperties(props, [
        "align",
        "children",
        "className",
        "data"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", _objectSpread({
        className: [
            'c-icon-list',
            "c-icon-list-".concat(align),
            className
        ].filter(function(item) {
            return item;
        }).join(' ')
    }, rest, {
        children: [
            data.map(function(icon, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IconListItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, icon), index);
            }),
            children
        ]
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconList);


/***/ }),

/***/ 7731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_base_anchor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5900);
/* harmony import */ var _components_base_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconListItem = function(props) {
    var icon = props.icon, text = props.text, anchor = props.anchor, rest = _objectWithoutProperties(props, [
        "icon",
        "text",
        "anchor"
    ]);
    var Body = function() {
        if (text) {
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, icon))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c-iconlist-item-label",
                            children: text
                        })
                    })
                ]
            }));
        }
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, icon)));
    };
    if (anchor) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_anchor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
            className: "c-iconlist-item-anchor",
            title: text
        }, anchor, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {})
        })));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: "c-iconlist-item"
    }, rest, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {})
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconListItem);


/***/ }),

/***/ 4360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _IconList__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "M": function() { return /* reexport safe */ _IconListItem__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _IconList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3340);
/* harmony import */ var _IconListItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7731);




/***/ }),

/***/ 3015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ header_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/anchor/index.tsx
var base_anchor = __webpack_require__(5900);
// EXTERNAL MODULE: ./components/base/icon/index.tsx
var icon = __webpack_require__(2676);
// EXTERNAL MODULE: ./services/http/wap/http.ts + 41 modules
var http = __webpack_require__(5172);
// EXTERNAL MODULE: ./node_modules/dot-prop/index.js
var dot_prop = __webpack_require__(6833);
;// CONCATENATED MODULE: ./services/http/wap/page/enums.ts
var EntityFieldType;
(function(EntityFieldType) {
    EntityFieldType[EntityFieldType["Boolean"] = 0] = "Boolean";
    EntityFieldType[EntityFieldType["Color"] = 1] = "Color";
    EntityFieldType[EntityFieldType["Date"] = 2] = "Date";
    EntityFieldType[EntityFieldType["Editor"] = 3] = "Editor";
    EntityFieldType[EntityFieldType["File"] = 4] = "File";
    EntityFieldType[EntityFieldType["Image"] = 5] = "Image";
    EntityFieldType[EntityFieldType["Link"] = 6] = "Link";
    EntityFieldType[EntityFieldType["LongText"] = 7] = "LongText";
    EntityFieldType[EntityFieldType["Number"] = 8] = "Number";
    EntityFieldType[EntityFieldType["Picture"] = 9] = "Picture";
    EntityFieldType[EntityFieldType["Price"] = 10] = "Price";
    EntityFieldType[EntityFieldType["Reference"] = 11] = "Reference";
    EntityFieldType[EntityFieldType["Text"] = 12] = "Text";
    EntityFieldType[EntityFieldType["Video"] = 13] = "Video";
})(EntityFieldType || (EntityFieldType = {}));

// EXTERNAL MODULE: ./services/http/wap/query/mappers.ts
var mappers = __webpack_require__(9278);
;// CONCATENATED MODULE: ./services/http/wap/mappers.ts



var getReferenceValue = function(param, refs) {
    var type = param.type, ref = param.ref, _mappings = param.mappings, mappings = _mappings === void 0 ? [] : _mappings;
    if (ref) {
        if (type === 'link') {
            var link = refs.links[ref];
            if (link) {
                return link.href;
            }
        } else if (type === 'navigation') {
            var menu = refs.navigations[ref];
            if (menu) {
                return menu;
            }
        } else if (type === 'query') {
            var query = refs.queries[ref];
            if (query) {
                return (0,mappers/* mapQuery */.w)(query, mappings);
            }
        } else if (type === 'string') {
            var string = refs.strings[ref];
            if (string) {
                return string;
            }
        } else if (type === 'page') {
            var field = refs.page[ref];
            if (field) {
                return field;
            }
        } else if (type === 'field') {
            var field1 = refs.fields[ref];
            if (field1) {
                if (Array.isArray(field1)) {
                    return mapPageFieldsByMappings(field1, mappings);
                }
                return field1;
            }
        } else {
            var file = refs.files[ref];
            if (file) {
                return file.path;
            }
        }
    }
    return null;
};
var getReference = function(tree, refs) {
    if (tree) {
        if ('type' in tree && 'ref' in tree) {
            tree = getReferenceValue(tree, refs);
        } else {
            for(var key in tree){
                var branch = tree[key];
                if (branch) {
                    if (Array.isArray(branch)) {
                        tree[key] = branch.map(function(leaf) {
                            return getReference(leaf, refs);
                        });
                    } else if (typeof branch === 'object') {
                        if ('type' in branch) {
                            if (branch.type === 'static') {
                                tree[key] = branch.label;
                            } else {
                                if ('ref' in branch) {
                                    tree[key] = getReferenceValue(branch, refs);
                                }
                            }
                        } else {
                            tree[key] = getReference(branch, refs);
                        }
                    } else {
                        tree[key] = branch;
                    }
                }
            }
        }
    }
    return tree;
};
var getNavigations = function(data) {
    var items = [];
    if (!data.children) return items;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var ref;
            items.push({
                title: item.title,
                href: ((ref = item.page) === null || ref === void 0 ? void 0 : ref.path) || item.staticUrl,
                icon: item.icon,
                target: item.target,
                className: item.className,
                children: getNavigations(item)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return items;
};
var getRefsObject = function(data, page) {
    var refs = {
        fields: {},
        files: {},
        navigations: {},
        links: {},
        queries: {},
        strings: {},
        page: {
            image: {},
            path: {},
            title: ''
        }
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ref = _step.value;
            if (ref.values) {
                if (ref.key === 'files') {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = ref.values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var file = _step1.value;
                            refs.files[file.id] = {
                                path: file.path,
                                mimetype: file.mimeType,
                                extension: file.extension,
                                size: file.size
                            };
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (ref.key === 'links') {
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = ref.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var link = _step2.value;
                            refs.links[link.id] = {
                                href: link.path,
                                title: link.title
                            };
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else if (ref.key === 'navigations') {
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = ref.values[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var menu = _step3.value;
                            refs.navigations[menu.id] = getNavigations(menu);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                } else if (ref.key === 'strings') {
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = ref.values[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var string = _step4.value;
                            refs.strings[string.id] = string.title;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                } else if (ref.key === 'queries') {
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator5 = ref.values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            var query = _step5.value;
                            refs.queries[query.id] = query.values.data;
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (page) {
        refs.page = {
            title: page.title,
            path: {
                href: page.path,
                children: page.title
            },
            image: page.image
        };
        refs.fields = page.fields || {};
    }
    return refs;
};
var getEntityRefsObject = function(type, data) {
    if (type === EntityFieldType.Link) {
        return getRefsObject([
            {
                key: 'links',
                values: data
            }
        ]);
    } else {
        return getRefsObject([
            {
                key: 'files',
                values: data
            }
        ]);
    }
};

;// CONCATENATED MODULE: ./services/http/wap/page/mappers.ts


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var mapPage = function(res) {
    var ref;
    var page = {
        id: res.data.id,
        alternates: res.data.alternates || [],
        language: res.data.languageId,
        layout: [],
        metatags: getReference(_objectSpread({}, res.data.metaTags), getRefsObject(res.data.refs)),
        path: res.data.path,
        theme: res.data.layout.themeId,
        title: res.data.title,
        fields: mapPageFields(((ref = res.data.dynamicEntity) === null || ref === void 0 ? void 0 : ref.columns) || []),
        image: getReference(_objectSpread({}, res.data.image), getRefsObject(res.data.refs)),
        views: getReference(_objectSpread({}, res.data.views), getRefsObject(res.data.refs)),
        refs: getRefsObject(res.data.refs)
    };
    return _objectSpread({}, page, {
        layout: (res.data.layout.schema || []).map(function(component) {
            return getReference(_objectSpread({}, component), getRefsObject(res.data.layout.refs, page));
        })
    });
};
var mapPageFields = function(columns) {
    var fields = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var column = _step.value;
            if (Array.isArray(column.data)) {
                fields[column.name] = column.data.map(function(item) {
                    return _objectSpread({}, getReference(item.value, getEntityRefsObject(column.type, item === null || item === void 0 ? void 0 : item.refs)), {
                        columns: item.columns.length ? mapPageFields(item.columns) : null
                    });
                });
            } else {
                if (column.data.value && typeof column.data.value === 'object') {
                    if (Array.isArray(column.data.value)) {
                        fields[column.name] = column.data.value.map(function(item) {
                            var ref;
                            return getReference(item, getEntityRefsObject(column.type, (ref = column.data) === null || ref === void 0 ? void 0 : ref.refs));
                        });
                    } else {
                        var ref1;
                        fields[column.name] = getReference(_objectSpread({}, column.data.value), getEntityRefsObject(column.type, (ref1 = column.data) === null || ref1 === void 0 ? void 0 : ref1.refs));
                    }
                } else {
                    fields[column.name] = column.data.value;
                }
            }
        };
        for(var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return fields;
};
var mapPageFieldsByMappings = function(field, mappings) {
    var data = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = field[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var value = {};
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = mappings[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var mapping = _step1.value;
                    var property = (0,dot_prop/* getProperty */.$s)({
                        value: item
                    }, mapping.path);
                    if (property) {
                        value[mapping.name] = property;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            data.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
};
var mapPagePath = function(res) {
    return res.data;
};

;// CONCATENATED MODULE: ./services/http/wap/page/endpoints.ts


var get = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/path?path=".concat(params.path)
    }, {
        res: mapPage
    });
};
var preview = function(environment, id) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/preview/".concat(id)
    }, {
        res: mapPage
    });
};
var findPath = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/".concat(params.language, "/find-path?path=").concat(params.path)
    }, {
        res: mapPagePath
    });
};
var globalSearch = function(environment, params) {
    return (0,http/* request */.W)(environment, {
        method: 'get',
        url: "/pages/".concat(params.language, "/global-search?pageLength=200&search=").concat(params.search)
    });
};

;// CONCATENATED MODULE: ./services/http/wap/page/index.ts



// EXTERNAL MODULE: ./components/base/button/index.tsx + 2 modules
var base_button = __webpack_require__(5664);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/widgets/header/Panel.tsx







var Panel = function(param) {
    var children = param.children, isOpen = param.isOpen, logo = param.logo;
    var app = (0,contexts_app/* useApp */.qD)();
    var router = (0,next_router.useRouter)();
    var handleLanguageSelection = function(language) {
        findPath(app.environment, {
            path: app.page.path,
            language: language
        }).then(function(slug) {
            router.push(utils/* path.app */.E.app(app.environment, slug));
        }).catch(function() {
            var homepagePath = app.settings.homepage;
            if (homepagePath) {
                findPath(app.environment, {
                    path: homepagePath,
                    language: language
                }).then(function(slug) {
                    router.push(utils/* path.app */.E.app(app.environment, slug));
                });
            }
        });
    };
    var renderLanguageSelection = function() {
        if (app.languages.length > 1) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "asg-header-language-selection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "asg-header-language-selection-current",
                        children: app.language.substring(0, 2)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "asg-header-language-selection-dropdown",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asg-header-language-selection-dropdown-list",
                            children: app.languages.map(function(language) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                        onClick: function() {
                                            return handleLanguageSelection(language.id);
                                        },
                                        children: language.title
                                    })
                                }, language.id));
                            })
                        })
                    })
                ]
            }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "panel panel--".concat(isOpen ? 'show' : 'hide'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel-body",
            style: {
                position: 'relative',
                flex: 1
            },
            children: children
        })
    }));
};
/* harmony default export */ var header_Panel = (Panel);

// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/icon-list/IconList.tsx
var IconList = __webpack_require__(3340);
// EXTERNAL MODULE: ./components/base/icon-list/index.ts
var icon_list = __webpack_require__(4360);
;// CONCATENATED MODULE: ./components/widgets/header/Navigation.tsx










var Navigation = function(param) {
    var data = param.data, isOpen1 = param.isOpen, headerHeight = param.headerHeight;
    var ref = (0,react.useState)(-1), activeSubMenu = ref[0], setActiveSubMenu = ref[1];
    var app = (0,contexts_app/* useApp */.qD)();
    var handleOpen = function(index) {
        setActiveSubMenu(index);
    };
    var renderNavs = function(navigation, index1) {
        var isChildren = index1 && typeof index1 === 'number';
        var isOpen = index1 === activeSubMenu;
        var isMain = activeSubMenu === -1 && !isChildren;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (0,functions.classnames)('navigation-menu', (isOpen || isMain) && 'navigation-menu--active', !isChildren && 'navigation-menu--main'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: navigation.map(function(menuItem, index) {
                        var title = menuItem.title;
                        if (menuItem.children.length) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: menuItem.className,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                        onClick: function() {
                                            return handleOpen(index);
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: title
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        name: "icon-arrow-right",
                                        className: "menu-item-arrow",
                                        size: "small"
                                    })
                                ]
                            }, index));
                        }
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: menuItem.className,
                            children: menuItem.href.indexOf('http') === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: menuItem.href,
                                target: menuItem.target,
                                dangerouslySetInnerHTML: {
                                    __html: title
                                },
                                rel: "noreferrer"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                className: (0,functions.classnames)(app.page.path === menuItem.href && 'current'),
                                href: menuItem.href,
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            })
                        }, index));
                    })
                })
            })
        }));
    };
    var renderContent = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "navigation-content scrollbar",
            children: [
                data.map(function(item, index) {
                    if (item.children && item.children.length) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (0,functions.classnames)('back-button', activeSubMenu !== -1 ? 'active' : 'disable'),
                                    onClick: function() {
                                        return setActiveSubMenu(-1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        name: "reply"
                                    })
                                }),
                                renderNavs(item.children, index)
                            ]
                        }));
                    }
                }),
                renderNavs(data)
            ]
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(header_Panel, {
        isOpen: isOpen1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "navigation",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "navigation-in",
                children: [
                    renderContent(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                        className: "navigation-footer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "navigation-footer-contact",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title",
                                        children: "\xc7ağrı Merkezi"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                        href: "tel:0850 850 09 41",
                                        children: "0850 850 09 41"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                                xs: {
                                    align: 'center',
                                    justify: 'end'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconList/* default */.Z, {
                                        className: "social-media",
                                        children: [
                                            app.settings.socials['facebook'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-facebook',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['facebook'] || 'https://www.facebook.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['twitter'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-twitter',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['twitter'] || 'https://www.twitter.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['instagram'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-instagram',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['instagram'] || 'https://www.instagram.com/asggrup/', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['youtube'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-youtube',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['youtube'] || 'https://www.linkedin.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['linkedin'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-linkedin2',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['linkedin'] || 'https://www.linkedin.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var header_Navigation = (Navigation);

// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
// EXTERNAL MODULE: ./components/base/image/index.tsx
var base_image = __webpack_require__(6475);
// EXTERNAL MODULE: ./components/base/anchor/Anchor.tsx
var Anchor = __webpack_require__(3357);
// EXTERNAL MODULE: ./components/base/icon/Icon.tsx
var Icon = __webpack_require__(6653);
;// CONCATENATED MODULE: ./components/widgets/header/Header.tsx














function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Header = function(param) {
    var logo = param.logo, navigation = param.navigation, isHome = param.isHome;
    var app = (0,contexts_app/* useApp */.qD)();
    var width = (0,useWidthResize/* useWidth */.z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), headerHeight = ref[0], setHeaderHeight = ref[1];
    var ref1 = (0,react.useState)(''), panel = ref1[0], setPanel = ref1[1];
    var ref2 = (0,react.useState)(false), isDropdownOpen = ref2[0], setIsDropdownOpen = ref2[1];
    var ref3 = (0,react.useState)(null), menuActive = ref3[0], setMenuActive = ref3[1];
    var handleLanguageSelection = function(language) {
        findPath(app.environment, {
            path: app.page.path,
            language: language
        }).then(function(slug) {
            router.push(utils/* path.app */.E.app(app.environment, slug));
        }).catch(function() {
            var homepagePath = app.settings.homepage;
            if (homepagePath) {
                findPath(app.environment, {
                    path: homepagePath,
                    language: language
                }).then(function(slug) {
                    router.push(utils/* path.app */.E.app(app.environment, slug));
                });
            }
        });
    };
    var openLanguage = function() {
        setIsDropdownOpen(!isDropdownOpen);
    };
    var handleClick = function(index) {
        setMenuActive(function(prevIndex) {
            return prevIndex === index ? null : index;
        });
    };
    var renderLanguageSelection = function() {
        if (app.languages.length > 1) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-body-language-selection",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "header-body-language-selection-list",
                    children: [
                        width <= 768 && app.languages.map(function(language) {
                            if (app.language === language.name) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (0,functions.classnames)(panel === 'menu' && 'active'),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                        onClick: openLanguage,
                                        className: "current",
                                        children: language.name.substring(0, 2)
                                    })
                                }, language.id));
                            } else {
                                return null // Return null or other JSX if needed
                                ;
                            }
                        }),
                        width <= 768 && isDropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ggm-header-body-language-selection-list-dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "ggm-header-body-language-selection-list-dropdown-list",
                                children: app.languages.map(function(language) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        className: (0,functions.classnames)(panel === 'menu' && 'active'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                            onClick: function() {
                                                return handleLanguageSelection(language.id);
                                            },
                                            children: language.title
                                        })
                                    }, language.id);
                                })
                            })
                        }),
                        width > 768 && app.languages.map(function(language) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: (0,functions.classnames)(panel === 'menu' && 'active'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                    onClick: function() {
                                        return handleLanguageSelection(language.id);
                                    },
                                    className: (0,functions.classnames)(app.language === language.name && 'current'),
                                    children: language.name.substring(0, 2)
                                })
                            }, language.id);
                        })
                    ]
                })
            }));
        }
    };
    (0,react.useEffect)(function() {
        var handleRouteChangeComplete = function() {
            document.body.style.overflow = '';
            setPanel('');
        };
        next_router["default"].events.on('routeChangeComplete', handleRouteChangeComplete);
        return function cleanup() {
            next_router["default"].events.off('routeChangeComplete', handleRouteChangeComplete);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (0,functions.classnames)('header', !isHome && 'header--not-home'),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,functions.classnames)('header-body', app.theme.title === 'Light' && 'reverse'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                        size: "fluid",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                            xs: {
                                justify: 'between',
                                align: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        className: "header-body-logo",
                                        href: app.settings.homepage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], Header_objectSpread({}, (logo === null || logo === void 0 ? void 0 : logo.src) ? logo : app.theme.logo, {
                                            alt: app.page.title
                                        }))
                                    })
                                }),
                                width > 960 && /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        className: "header-body-desktop-menu",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: navigation === null || navigation === void 0 ? void 0 : navigation.map(function(menuItem, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: (0,functions.classnames)(menuItem.className, menuItem.children.length && 'hasSubMenu', menuActive === index && 'active'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return handleClick(index);
                                                        },
                                                        onKeyDown: function() {
                                                            return handleClick(index);
                                                        },
                                                        role: "button",
                                                        tabIndex: 0,
                                                        children: [
                                                            menuItem.children.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
                                                                onClick: function(e) {
                                                                    return e.preventDefault();
                                                                },
                                                                children: [
                                                                    menuItem.title,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                        name: "keyboard-arrow-down"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                                href: menuItem.href,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: menuItem.title
                                                                }
                                                            }),
                                                            menuItem.children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "sub-menu",
                                                                children: menuItem.children.map(function(subItem, subIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                                            href: subItem.href,
                                                                            children: subItem.title
                                                                        })
                                                                    }, subIndex);
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: renderLanguageSelection()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                                className: (0,functions.classnames)('header-body-menu-button', panel === 'menu' && 'active'),
                                                onClick: function() {
                                                    panel === 'menu' ? setPanel('') : setPanel('menu');
                                                },
                                                children: panel == 'menu' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    name: "cancel",
                                                    size: "medium"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    name: "icon-menu",
                                                    size: "medium"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                navigation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Navigation, {
                    isOpen: panel === 'menu',
                    data: navigation,
                    logo: logo,
                    headerHeight: headerHeight
                }) : null
            ]
        })
    }));
};
/* harmony default export */ var header_Header = (Header);

;// CONCATENATED MODULE: ./components/widgets/header/index.tsx



/***/ }),

/***/ 9278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ mapQuery; }
/* harmony export */ });
/* harmony import */ var dot_prop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6833);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getReferenceValue = function(param, refs) {
    var type = param.type, ref = param.ref;
    if (ref) {
        var reference = refs.find(function(item) {
            return item.id === ref;
        });
        if (reference) {
            var types = [
                'image',
                'file',
                'video',
                'link'
            ];
            if (types.includes(type)) {
                return reference.path;
            } else {
                return reference;
            }
        }
    }
    return null;
};
var getReference = function(tree, refs) {
    if (tree) {
        if ('type' in tree && 'ref' in tree) {
            tree = getReferenceValue(tree, refs);
        } else {
            for(var key in tree){
                var branch = tree[key];
                if (branch) {
                    if (Array.isArray(branch)) {
                        tree[key] = branch.map(function(leaf) {
                            return getReference(leaf, refs);
                        });
                    } else if (typeof branch === 'object') {
                        if ('type' in branch) {
                            if (branch.type === 'static') {
                                tree[key] = branch.label;
                            } else {
                                if ('ref' in branch) {
                                    tree[key] = getReferenceValue(branch, refs);
                                }
                            }
                        } else {
                            tree[key] = getReference(branch, refs);
                        }
                    } else {
                        tree[key] = branch;
                    }
                }
            }
        }
    }
    return tree;
};
var getQueryMapping = function(item, mappings) {
    var value = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mappings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mapping = _step.value;
            var property = (0,dot_prop__WEBPACK_IMPORTED_MODULE_0__/* .getProperty */ .$s)(item, mapping.path);
            if (property) {
                // console.log({ property, mappings })
                if (typeof property === 'object') {
                    if (Array.isArray(property)) {
                        var data = [];
                        var properties = property;
                        var mappings1 = mapping.children || [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = properties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var prop = _step1.value;
                                var result = getQueryMapping(prop, mappings1.map(function(child) {
                                    return _objectSpread({}, child, {
                                        path: child.path.replace("".concat(mapping.path, "."), '')
                                    });
                                }));
                                data.push(result);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        value[mapping.name] = data;
                    } else {
                        if (property['value'] && property['refs']) {
                            var data1 = getReference(property['value'], property['refs']);
                            value[mapping.name] = data1;
                        } else {
                            var mappings2 = mapping.children || [];
                            if (mappings2.length) {
                                value[mapping.name] = getQueryMapping(item, mappings2);
                            } else {
                                value[mapping.name] = property;
                            }
                        }
                    }
                } else {
                    if (mapping.type === 'link') {
                        value[mapping.name] = {
                            href: property
                        };
                    } else {
                        value[mapping.name] = property;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return value;
};
var mapQuery = function(query, mappings) {
    if (Array.isArray(query)) {
        var data = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                data.push(getQueryMapping(item, mappings));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return data;
    } else {
        return getQueryMapping(query, mappings);
    }
};


/***/ }),

/***/ 6833:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ getProperty; }
/* harmony export */ });
/* unused harmony exports setProperty, deleteProperty, hasProperty, escapePath, deepKeys */
const isObject = value => {
	const type = typeof value;
	return value !== null && (type === 'object' || type === 'function');
};

const disallowedKeys = new Set([
	'__proto__',
	'prototype',
	'constructor',
]);

const digits = new Set('0123456789');

function getPathSegments(path) {
	const parts = [];
	let currentSegment = '';
	let currentPart = 'start';
	let isIgnoring = false;

	for (const character of path) {
		switch (character) {
			case '\\':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				if (isIgnoring) {
					currentSegment += character;
				}

				currentPart = 'property';
				isIgnoring = !isIgnoring;
				break;

			case '.':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					currentPart = 'property';
					break;
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += character;
					break;
				}

				if (disallowedKeys.has(currentSegment)) {
					return [];
				}

				parts.push(currentSegment);
				currentSegment = '';
				currentPart = 'property';
				break;

			case '[':
				if (currentPart === 'index') {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					currentPart = 'index';
					break;
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += character;
					break;
				}

				if (currentPart === 'property') {
					if (disallowedKeys.has(currentSegment)) {
						return [];
					}

					parts.push(currentSegment);
					currentSegment = '';
				}

				currentPart = 'index';
				break;

			case ']':
				if (currentPart === 'index') {
					parts.push(Number.parseInt(currentSegment, 10));
					currentSegment = '';
					currentPart = 'indexEnd';
					break;
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				// Falls through

			default:
				if (currentPart === 'index' && !digits.has(character)) {
					throw new Error('Invalid character in an index');
				}

				if (currentPart === 'indexEnd') {
					throw new Error('Invalid character after an index');
				}

				if (currentPart === 'start') {
					currentPart = 'property';
				}

				if (isIgnoring) {
					isIgnoring = false;
					currentSegment += '\\';
				}

				currentSegment += character;
		}
	}

	if (isIgnoring) {
		currentSegment += '\\';
	}

	switch (currentPart) {
		case 'property': {
			if (disallowedKeys.has(currentSegment)) {
				return [];
			}

			parts.push(currentSegment);

			break;
		}

		case 'index': {
			throw new Error('Index was not closed');
		}

		case 'start': {
			parts.push('');

			break;
		}
	// No default
	}

	return parts;
}

function isStringIndex(object, key) {
	if (typeof key !== 'number' && Array.isArray(object)) {
		const index = Number.parseInt(key, 10);
		return Number.isInteger(index) && object[index] === object[key];
	}

	return false;
}

function assertNotStringIndex(object, key) {
	if (isStringIndex(object, key)) {
		throw new Error('Cannot use string index');
	}
}

function getProperty(object, path, value) {
	if (!isObject(object) || typeof path !== 'string') {
		return value === undefined ? object : value;
	}

	const pathArray = getPathSegments(path);
	if (pathArray.length === 0) {
		return value;
	}

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		if (isStringIndex(object, key)) {
			object = index === pathArray.length - 1 ? undefined : null;
		} else {
			object = object[key];
		}

		if (object === undefined || object === null) {
			// `object` is either `undefined` or `null` so we want to stop the loop, and
			// if this is not the last bit of the path, and
			// if it didn't return `undefined`
			// it would return `null` if `object` is `null`
			// but we want `get({foo: null}, 'foo.bar')` to equal `undefined`, or the supplied value, not `null`
			if (index !== pathArray.length - 1) {
				return value;
			}

			break;
		}
	}

	return object === undefined ? value : object;
}

function setProperty(object, path, value) {
	if (!isObject(object) || typeof path !== 'string') {
		return object;
	}

	const root = object;
	const pathArray = getPathSegments(path);

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		assertNotStringIndex(object, key);

		if (index === pathArray.length - 1) {
			object[key] = value;
		} else if (!isObject(object[key])) {
			object[key] = typeof pathArray[index + 1] === 'number' ? [] : {};
		}

		object = object[key];
	}

	return root;
}

function deleteProperty(object, path) {
	if (!isObject(object) || typeof path !== 'string') {
		return false;
	}

	const pathArray = getPathSegments(path);

	for (let index = 0; index < pathArray.length; index++) {
		const key = pathArray[index];

		assertNotStringIndex(object, key);

		if (index === pathArray.length - 1) {
			delete object[key];
			return true;
		}

		object = object[key];

		if (!isObject(object)) {
			return false;
		}
	}
}

function hasProperty(object, path) {
	if (!isObject(object) || typeof path !== 'string') {
		return false;
	}

	const pathArray = getPathSegments(path);
	if (pathArray.length === 0) {
		return false;
	}

	for (const key of pathArray) {
		if (!isObject(object) || !(key in object) || isStringIndex(object, key)) {
			return false;
		}

		object = object[key];
	}

	return true;
}

function escapePath(path) {
	if (typeof path !== 'string') {
		throw new TypeError('Expected a string');
	}

	return path.replace(/[\\.[]/g, '\\$&');
}

// The keys returned by Object.entries() for arrays are strings
function entries(value) {
	if (Array.isArray(value)) {
		return value.map((value, index) => [index, value]);
	}

	return Object.entries(value);
}

function stringifyPath(pathSegments) {
	let result = '';

	for (let [index, segment] of entries(pathSegments)) {
		if (typeof segment === 'number') {
			result += `[${segment}]`;
		} else {
			segment = escapePath(segment);
			result += index === 0 ? segment : `.${segment}`;
		}
	}

	return result;
}

function * deepKeysIterator(object, currentPath = []) {
	if (!isObject(object)) {
		if (currentPath.length > 0) {
			yield stringifyPath(currentPath);
		}

		return;
	}

	for (const [key, value] of entries(object)) {
		yield * deepKeysIterator(value, [...currentPath, key]);
	}
}

function deepKeys(object) {
	return [...deepKeysIterator(object)];
}


/***/ })

}]);